import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import { Marker, InfoBox } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import NewRelicService from 'services/NewRelic'
import style from './style.scss';//NOSONAR

let actions =  [];

const Markers = ({location, isReference}) =>  {

    const [marker, setMarker] = useState({
        lat: location.lat(),
        lng: location.lng()
    });
    const [isReferenceState] = useState(isReference);
    const [outLimit, setOutLimit] = useState(false);
    const [isOtherStreet, setIsOtherStreet] = useState(false);
    const [infoVisible, setInfoVisible] = useState(true);
    let settings = {
        animation: google.maps.Animation.DROP
    };

    useEffect(() => {
        actions.push(PubSub.register('address_reference_change_out_limit', _alertMarker));
        actions.push(PubSub.register('address_reference_change_other_street', _otherStreet));

        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
        }
    },[]);

    const initPosition = () => {
        setInfoVisible(false);
    }

    const changePosition = (event) => {
        if(outLimit || isOtherStreet){
            setMarker({
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            });
            setOutLimit(false);
            setIsOtherStreet(false);
            setInfoVisible(true);

        } else {
            NewRelicService.sendPageAction({
                action: 'modalAddress',
                payload: {
                    status: 'mapPointChange',
                    location: event && event.latLng ? event.latLng.lat() + ', ' +  event.latLng.lng() : null
                }
            });
            setMarker({
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            });
        }
        PubSub.dispatch("address_reference_change", {
            latLng: event.latLng
        });
    }

    const _alertMarker = (payload) => {
        const {location: coordinate} = payload.value;
        
        setMarker({
            lat: coordinate.lat(),
            lng: coordinate.lng()
        });
        setOutLimit(true);
        setInfoVisible(true);

        NewRelicService.sendPageAction({
            action: 'modalAddress',
            payload: {
                status: 'mapPointAlert',
                outLimit: true,
                isOtherStreet,
                location: coordinate ? coordinate.lat() + ', ' +  coordinate.lng() : null
            }
        })
    }

    const _otherStreet = (payload) => {
        const {location: coordinate} = payload.value;

        setMarker({
            lat: coordinate.lat(),
            lng: coordinate.lng()
        });
        setIsOtherStreet(true);
        setOutLimit(false);
        setInfoVisible(true);

        NewRelicService.sendPageAction({
            action: 'modalAddress',
            payload: {
                status: 'mapPointAlert',
                outLimit,
                otherStreet: true,
                location: coordinate ? coordinate.lat() + ', ' +  coordinate.lng() : null
            }
        })
    }

    if(!marker) return '';

    return (
        <Marker
            position={{ lat: marker.lat, lng: marker.lng }}
            animation={settings.animation}
            draggable={isReferenceState}
            onDragStart={initPosition}
            onDragEnd={changePosition}>
            {infoVisible && outLimit && <InfoBox
                position={{ lat: marker.lat, lng: marker.lng }}
                options={{ closeBoxURL: ``, enableEventPropagation: true }}>
                <div className={'modal-address-marker-info alert'}>
                    Moviste el pin muy lejos del punto de referencia.
                </div>
            </InfoBox>}
            {infoVisible && isOtherStreet && <InfoBox
                position={{ lat: marker.lat, lng: marker.lng }}
                options={{ closeBoxURL: ``, enableEventPropagation: true }}>
                <div className={'modal-address-marker-info alert'}>
                    Moviste el pin para otra calle.
                </div>
            </InfoBox>}
        </Marker>
    )
    
}

Markers.propTypes = {
    isReference: PropTypes.bool,
    location: PropTypes.object
};

export default Markers;
